import React from 'react'
import { Layout, Header, Work, Info, Seo } from '../components'
import { graphql } from 'gatsby'

const WorkPage = ({ data }) => {
  const {
    allAgilityproject: { nodes: work },
  } = data

  return (
    <Layout>
      <Seo title="Work Page" description="This page displays some of our previous work" />
      <Header text="We create memorable experiences. here’s some of our work" />
      <Work work={work} page />
      <Info />
    </Layout>
  )
}

export const query = graphql`
  {
    allAgilityproject {
      nodes {
        id
        customFields {
          featured
          name
          tag
          url
          image {
            label
            url
            filesize
            pixelHeight
            pixelWidth
            height
            width
          }
        }
      }
    }
  }
`

export default WorkPage
